import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
const responseParser = (data: any) => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw {
      message: 'Favorite transaction service is temporarily unavailable.',
      code: 'SERVER_ERROR_500',
    }
  }
  if (data?.data?.errorCode === '000') {
    console.log('data at try block in responseParser manageFavTxnsApi', data)
    return data.data.responseObj
  } else {
    console.log('data at catch block in responseParser manageFavTxnsApi', data.data)
    // throw getNetworkResponseError(data?.data)
    const errorBody = data?.data || data || { message: 'Action failed' }
    console.log('Error in responseParser manageFavTxnsApi:', errorBody)

    // Pass a safe object to the restricted util function
    throw getNetworkResponseError(errorBody)
  }
}

interface ManageFavTxnsBody {
  orderId: string
  setFavTxn: 'Y' | 'N'
  remarks: string
}

export const manageFavTxnsApi = (tokens: any, body: ManageFavTxnsBody) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || ''
  //   config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A'
  config.headers['x-channelId'] = RootStore.agent.session.CHANNEL_ID || ''
  config.headers['x-channel-user-id'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  //   config.headers['x-intercept-gateway'] = 'SERVICE/JPB'

  const requestBody = {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'Manage favorite transactions',
    },
    initiatingEntity: {
      entityId: RootStore.agent.session.CHANNEL_ID || '',
      channelId: RootStore.agent.session.CHANNEL_ID || '',
    },
    order: {
      id: body.orderId,
    },
    favTxn: {
      setFavTxn: body.setFavTxn,
      remarks: body.remarks,
    },
  }

  const request: Request<{}> = {
    apiPath: APIEndPoints.manageFavoriteTransactionsBC,
    method: 'POST',
    config: config,
    body: requestBody,
  }

  console.log('API_DEBUG: manageFavTxnsApi FINAL Request Body:', JSON.stringify(requestBody))
  console.log('API_DEBUG: manageFavTxnsApi Headers Check:', {
    'x-channel-user-id': config.headers['x-channel-user-id'],
    'x-mobileNumber': config.headers['x-mobileNumber'],
    'x-user-access-token': config.headers['x-user-access-token'] ? 'PRESENT' : 'MISSING',
  })

  sendEventApi(tokens, request, { status: 'INITIATED' })

  return executeRequest(request)
    .then((data) => {
      console.log('manageFavTxnsApi requestBody:', requestBody)
      console.log('API_DEBUG: manageFavTxnsApi RAW Response Data:', JSON.stringify(data))
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, { status: 'SUCCESS' })
      console.log('API_DEBUG: manageFavTxnsApi PARSED Success Response:', JSON.stringify(response))
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      console.error('API_DEBUG: manageFavTxnsApi FAILED with error:', JSON.stringify(err))
      throw err
    })
}
